import axios from "axios";
import Vue from "vue";
import configuration from "@/utils/configuration";
import { handleError } from "@/utils/errorHandler";

const getDefaultState = () => {
  return {
    course_selection: {
      category_id: null,
      category_name_th: null,
      category_name_en: null,
      course_type_code: null,
      course_package_option_id: null,
      course_id: null,
      course_name_th: null,
      course_name_en: null,
      package_id: null,
      package_name_th: null,
      package_name_en: null,
      option_id: null,
      option_name_th: null,
      option_name_en: null,
      price: null,
      discount: null,
      coach_id: null,
      course_coach_id:null,
      coach_first_name_th: null,
      coach_last_name_th: null,
      coach_first_name_en: null,
      coach_last_name_en: null,
      day_of_week: null,
      start_time: null, 
      end_time: null,
      study_start_date: null,
      other_discount: 0,
      remark: null,
      learner: [],
      course_per_time: null,
      hour_per_time:null,
      study_end_date:null
    },
    cartList: [],
    cartCount: parseInt(localStorage.getItem('cartCount')) || 0,
    availableSeat:null,
    courseAvailableStatus: null,
    addLearnerError: null,
    progress: {
      step1: false,
      step2: false,
      step3: false
    },
        
    loading: {},
    error: {},
  };
};

const state = getDefaultState();

export default {
  namespaced: true,
  state,
  getters: {
    cartList: (state) => state.cartList,
    cartCount: (state) => state.cartCount,
    courseSelection: (state) => state.course_selection,
    availableSeat: (state) => state.availableSeat,
    step1Progress: (state) => state.progress.step1 || false,
    step2Progress: (state) => state.progress.step2 || false,
    step3Progress: (state) => state.progress.step3 || false,
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
    courseTodayStatus: (state) => state.courseAvailableStatus,
  },
  mutations: {
    RESET_COURSE_SELECTION(state) {
      Object.assign(state, getDefaultState());
    },
    RESET_PROGRESS(state) {
      state.progress = {
        step1: false,
        step2: false,
        step3: false
      };
    },
    SET_COURSE_SELECTION(state, payload) {
      state.course_selection = {
        ...state.course_selection,
        ...payload
      };
    },
    ADD_LEARNER(state, learner) {
      const isDuplicate = state.course_selection.learner.some(
        existingLearner => existingLearner.user_id === learner.user_id
      );

      if (isDuplicate) {
        throw new Error("Duplicate user ID found.");
      } else {
        state.course_selection.learner.push(learner);
        state.progress.step3 = state.course_selection.learner.length > 0;
        state.addLearnerError = null;
      }
    },
    REMOVE_LEARNER(state, learnerId) {
      state.course_selection.learner = state.course_selection.learner.filter(
        learner => learner.user_id !== learnerId
      );
      state.progress.step3 = state.course_selection.learner.length > 0;
    },
    SET_PROGRESS(state, payload) {
      state.progress = {
        ...state.progress,
        ...payload
      };
    },
    SET_SEAT(state, { currentSeat, maximumSeat }) {
      state.availableSeat = maximumSeat - currentSeat
    },
    SET_COURSE_STATUS(state,courseStatus) {
      state.courseAvailableStatus = courseStatus;
    },
    INCREMENT_CURRENT_SEAT(state) {
      state.currentSeat += 1;
    },
    DECREMENT_CURRENT_SEAT(state, count = 1) {
      state.currentSeat = Math.max(0, state.currentSeat - count);
    },
    REMOVE_ALL_LEARNERS_EXCEPT_SELF(state, selfUserId) {
      const originalLength = state.course_selection.learner.length;
      state.course_selection.learner = state.course_selection.learner.filter(
        learner => learner.user_id === selfUserId
      );
      const newLength = state.course_selection.learner.length;
      const removedCount = originalLength - newLength;
      state.currentSeat = Math.max(0, state.currentSeat - removedCount);
      state.progress.step3 = state.course_selection.learner.length > 0;
    },
    SET_LEARNER_PARENT_ID(state, parentId) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user.userId) {
        state.course_selection.learner = state.course_selection.learner.map(learner => {
          if (learner.user_id === user.userId) {
            return { ...learner, parent_id: parentId };
          }
          return learner;
        });
      }
    },
    REMOVE_LEARNER_PARENT_ID(state) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user.userId) {
        state.course_selection.learner = state.course_selection.learner.map(learner => {
          if (learner.user_id === user.userId) {
            return { ...learner, parent_id: null };
          }
          return learner;
        });
      }
    },
    SET_LOADING(state, { action, status }) {
      Vue.set(state.loading, action, status);
    },
    SET_ERROR(state, { action, message }) {
      Vue.set(state.error, action, message);
    },
    CLEAR_ERROR(state, action) {
      Vue.set(state.error, action, null);
    },
    CLEAR_ALLERRORS(state) {
      state.error = {};
    },
     SET_CART_LIST(state,cartList){
      state.cartList = cartList
    },
    SET_CART_COUNT(state, count) {
  state.cartCount = count;
  localStorage.setItem('cartCount', count);  
},
INCREMENT_CART_COUNT(state) {
  state.cartCount += 1;
  localStorage.setItem('cartCount', state.cartCount);
},
DECREMENT_CART_COUNT(state) {
  state.cartCount = Math.max(0, state.cartCount - 1);
  localStorage.setItem('cartCount', state.cartCount);
},

  },
  actions: {
    clearErrorMessage({ commit, state }, action) {
      if (state.error[action]) {
        commit('CLEAR_ERROR', action);
      } 
    },
    clearAllErrors({ commit }) {
      commit('CLEAR_ALL_ERRORS');
    },
    updateSelection({ commit }, payload) {
      commit('SET_COURSE_SELECTION', payload);
    },
    addLearner({ commit, state }, learner) {
      try {
        commit('ADD_LEARNER', learner);
        commit('INCREMENT_CURRENT_SEAT');
        commit('SET_PROGRESS', { step3: state.course_selection.learner.length > 0 });
      } catch (error) {
        state.addLearnerError = error.message;
      }
    },
    removeLearner({ commit, state }, learnerId) {
      commit('REMOVE_LEARNER', learnerId);
      commit('DECREMENT_CURRENT_SEAT');
      commit('SET_PROGRESS', { step3: state.course_selection.learner.length > 0 });
    },
    removeAllLearnersExceptSelf({ commit, state }) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user.userId) {
        const originalLength = state.course_selection.learner.length;
        commit('REMOVE_ALL_LEARNERS_EXCEPT_SELF', user.userId);
        const newLength = state.course_selection.learner.length;
        const removedCount = originalLength - newLength;
        commit('DECREMENT_CURRENT_SEAT', removedCount);
      }
    },
    addParentIdToLearner({ commit }, parentId) {
      commit('SET_LEARNER_PARENT_ID', parentId);
    },
    removeParentIdFromLearner({ commit }) {
      commit('REMOVE_LEARNER_PARENT_ID');
    },
    updateProgress({ commit }, payload) {
      commit('SET_PROGRESS', payload);
    },
    setSeat({ commit }, currentSeat,maximumSeat) {
      commit("SET_SEAT", currentSeat,maximumSeat);
    },
    setCourseAvaliableStatus({ commit }, courseStatus) {
      commit("SET_COURSE_STATUS", courseStatus);
    },
    async postOrderPayment({ state, commit }) {
      const action = "postOrderPayment";
      commit("SET_LOADING", { action, status: true });
      try {
        const payload = {courses: [{ ...state.course_selection }]};
        const response = await axios({
          method: "POST",
          url: `${configuration.orderUrl}/payment`,
          data: payload,
          withCredentials: true,
        });
        return response.data;
      } catch (error) {
        // Handle error
        const errorMessage = error.response?.data?.message || error.message || `${action} Failed`;
        commit("SET_ERROR", {
          action,
          message: errorMessage,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postCart({ state, commit }) {
      const action = "postCart";
      commit("SET_LOADING", { action, status: true });
      try {
        const payload = {
          courses: [
            { ...state.course_selection }
          ]
        };
        const response = await axios({
          method: "POST",
          url: `${configuration.backUrl}/carts/product`,
          data: payload,
          withCredentials: true,
        });
        commit("INCREMENT_CART_COUNT");
        return response.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message: error.response?.data?.message || error.message || `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postReserve({ state, commit }) {
      const action = "postReserve";
      commit("SET_LOADING", { action, status: true });
      try {
        const payload = {
          courses: [
            { ...state.course_selection }
          ]
        };
        const response = await axios({
          method: "POST",
          url: `${configuration.backUrl}/reserve/product`,
          data: payload,
          withCredentials: true,
        });
        return response.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message: error.response?.data?.message || error.message || `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async addLearnerToCourse({ commit },payload) {
      const action = "addLearnerToCourse";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.orderUrl}/product`,
          withCredentials: true,
          data:payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getPurchaseDetail({ commit },orderNumber) {
      const action = "getPurchaseDetail";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.orderUrl}/detail/${orderNumber}`,
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    //--------------  Cart Management --------------------
        async getCartList({ commit }) {
        const action = "getCartList";
        commit("SET_LOADING", { action, status: true });
        try {
          const { data } = await axios({
            method: "GET",
            url: `${configuration.backUrl}/carts/user`,
            withCredentials: true,
          });
         
          commit("SET_CART_LIST", data.data);
          commit("SET_CART_COUNT", data.data.length); 
          return data.data
        } catch (error) {
          commit("SET_ERROR", {action,message:error.response?.data?.message ||error.message ||`${action} Failed`,});
        } finally {
          commit("SET_LOADING", { action, status: false });
        }
      },
      async deleteCartProduct({ commit },cartId) {
        const action = "deleteCartProduct";
        commit("SET_LOADING", { action, status: true });
        try {
          const { data } = await axios({
            method: "DELETE",
            url: `${configuration.backUrl}/carts/products`,
            params:{cart_id:cartId},
            withCredentials: true,
          });
          commit("SET_CART_LIST", data.data);
          return data.data
        } catch (error) {
          commit("SET_ERROR", {action,message:error.response?.data?.message ||error.message ||`${action} Failed`,});
        } finally {
          commit("SET_LOADING", { action, status: false });
        }
      },

      async postCartPayment({ commit },cartId) {
        const action = "postCartPayment";
        commit("SET_LOADING", { action, status: true });
        try {
          const { data } = await axios({
            method: "POST",
            url:  `${configuration.orderUrl}/cart-payment`,
            params:{cart_id:cartId},
            withCredentials: true,
          });
          commit("DECREMENT_CART_COUNT");
          return data.data
        } catch (error) {
          commit("SET_ERROR", {action,message:error.response?.data?.message ||error.message ||`${action} Failed`,});
        } finally {
          commit("SET_LOADING", { action, status: false });
        }
      },
  },
};